import React, { useEffect, useMemo, useRef, useState } from 'react';
import { createUseStyles } from 'react-jss';
import Lottie from 'react-lottie-player';
import FadeIn from 'react-fade-in/lib/FadeIn';
import tinycolor from 'tinycolor2';
import { Button } from 'react-bootstrap';
import { useTimer } from 'react-timer-hook';
import _ from 'lodash';
import dayjs from 'dayjs';
import iconData from './gps.json';
import { layoutDefaults } from '../../utils/layout-defaults';
import { LocationIcon } from './location-icon';
import { useShake } from '../../hooks/use-shake';
import { useGoogleMapsGeocoder } from '../../hooks/use-google-maps-geocoder';
import { isDevEnv } from '../../utils/manager/host-manager';

const accuracy = isDevEnv ? 25 : 10;

function AddressCurrentLocationModalBody({ onMessage, onSuccess, onError }) {
  // const [firstTry, setFirstTry] = useState(true);
  const [loading, setLoading] = useState(true);
  const classes = useStyles({ loading });
  const { isGeocoderLoaded, geocoder } = useGoogleMapsGeocoder();

  // eslint-disable-next-line no-undef
  const geolocation = useMemo(() => navigator.geolocation, []);

  const watchIdRef = useRef();
  const descriptionRef = useRef();

  useShake(
    {
      element: descriptionRef?.current,
      enabled: loading,
    },
    [loading]
  );

  function getExpiryTimestamp() {
    if (isDevEnv) {
      return dayjs().add(10, 'second').toDate();
    }

    return dayjs().add(1, 'minute').toDate();
  }

  const clearWatch = () => {
    if (watchIdRef.current != null) {
      try {
        geolocation?.clearWatch(watchIdRef.current);
      } catch (error) {
        // TODO Just ignore
      }

      watchIdRef.current = null;
      pause();
    }
  };

  useEffect(() => {
    if (loading && isGeocoderLoaded && watchIdRef != null) {
      onMessage?.call(this, null);
      restart(getExpiryTimestamp(), true);

      load();
    }

    return clearWatch;
  }, [loading, watchIdRef, isGeocoderLoaded]);

  const {
    seconds,
    minutes,
    // isRunning,
    // start,
    pause,
    // resume,
    restart,
  } = useTimer({
    expiryTimestamp: getExpiryTimestamp(),
    onExpire: () => {
      setLoading(false);
      onMessage?.call(this, 'Não foi possível obter a localização');
    },
  });

  const time = useMemo(
    () => `${_.padStart(minutes, 2, '0')}:${_.padStart(seconds, 2, '0')}`,
    [seconds, minutes]
  );

  const handleOnCompleteFadeIn = () => {
    setLoading(true);
  };

  async function handleOnSuccessGetCurrentPosition(position) {
    if (!isGeocoderLoaded) return;

    const { coords } = position;
    const result = await geocoder?.geocode({
      location: { lat: coords.latitude, lng: coords.longitude },
    });

    const placeDetails = _.head(result?.results);

    if (placeDetails != null) {
      clearWatch();
      await onSuccess?.call(this, placeDetails);
    }
  }

  function handleOnError(error) {
    setLoading(false);
    // setLoadingSelection(false);

    console.log('xxxxxxxxxx', error);

    clearWatch();
    onError?.call(this, error);
  }

  // function handleTimeout(setLoading, id) {
  //   setLoading(false);
  //   setLoadingSelection(false);

  //   geolocation.clearWatch(id);
  //   onTimeout?.call(this);
  // }

  // const load = useCallback(() => {
  //   if (watchIdRef.current != null) return;

  //   _.delay(() => {
  //     try {
  //       if (watchIdRef.current != null) return;

  //       watchIdRef.current = geolocation.watchPosition(
  //         (position) => {
  //           console.log('position', position?.coords?.accuracy);

  //           if (position.coords.accuracy < accuracy) {
  //             console.log('position FOOOOOII!!!', position?.coords?.accuracy);
  //             handleOnSuccessGetCurrentPosition(position);
  //           }
  //         },
  //         (error) => handleOnError(error),
  //         {
  //           enableHighAccuracy: true,
  //           // timeout: 1000,
  //           maximumAge: 1000,
  //         }
  //       );
  //     } catch (error) {
  //       handleOnError(error);
  //     }
  //   }, 3000);
  // }, [
  //   geolocation,
  //   watchIdRef,
  //   handleOnSuccessGetCurrentPosition,
  //   handleOnError,
  // ]);

  async function load() {
    if (watchIdRef.current != null) return;

    _.delay(() => {
      try {
        if (watchIdRef.current != null) return;

        watchIdRef.current = geolocation.watchPosition(
          (position) => {
            console.log('position', position?.coords?.accuracy);

            if (position.coords.accuracy < accuracy) {
              console.log('position FOOOOOII!!!', position?.coords?.accuracy);
              handleOnSuccessGetCurrentPosition(position);
            }
          },
          (error) => handleOnError(error),
          {
            enableHighAccuracy: true,
            // timeout: 1000,
            maximumAge: 1000,
          }
        );
      } catch (error) {
        handleOnError(error);
      }
    }, 3000);
  }

  return (
    <div className={classes.container}>
      <FadeIn
        className={classes.textContainer}
        delay={layoutDefaults.keyboardDuration}
        onComplete={handleOnCompleteFadeIn}
      >
        <div className={classes.title}>
          <LocationIcon /> {loading ? 'Buscando...' : 'Localização'}
        </div>
        <div className={classes.timerContainer}>
          {/* {loading && <div className={classes.timer}>{time}</div>} */}
          <div
            style={{
              color: loading === true ? 'white' : '#818181',
              background: loading === true ? '#a5b8ca' : '#e9e9e9',
            }}
            className={classes.timer}
          >
            {time}
          </div>
        </div>

        {loading && (
          <FadeIn>
            <div ref={descriptionRef} className={classes.description}>
              Vá para uma área aberta, varanda ou janela para melhorar o sinal
            </div>
          </FadeIn>
        )}

        {!loading && (
          <FadeIn delay={layoutDefaults.keyboardDuration}>
            <Button
              variant="link"
              onClick={() => setLoading(true)}
              className={classes.link}
            >
              Tentar novamente
            </Button>
          </FadeIn>
        )}
      </FadeIn>
      {loading && (
        <FadeIn className={classes.iconContainer}>
          <Lottie
            loop
            play={loading}
            animationData={iconData}
            className={classes.icon}
          />
        </FadeIn>
      )}
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    // height: 180,
    overflow: 'hidden',
    marginTop: -layoutDefaults.bigVerticalMargin,
    // border: '1px solid red',
  },
  iconContainer: {
    position: 'absolute',
    opacity: 0.16,
  },
  icon: {
    // height: 660,
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    // flex: 1,
    // alignItems: '',
    justifyContent: 'space-between',
    // alignItems: 'spe',

    // border: '1px solid red',
  },
  title: {
    fontSize: layoutDefaults.biggestFontSize,
    fontWeight: 'bold',

    marginTop: layoutDefaults.verticalMargin,
  },
  timerContainer: {
    // opacity: layoutDefaults.opacity,
    // height: 24,

    marginTop:
      layoutDefaults.biggestVerticalMargin +
      layoutDefaults.smallerVerticalMargin,
    marginBottom: layoutDefaults.bigVerticalMargin,

    // border: '1px solid blue',
  },
  timer: {
    display: 'inline',
    // flex: 1,
    fontSize: layoutDefaults.bigFontSize,
    // fontStyle: 'italic',
    // opacity: layoutDefaults.opacity,
    fontFamily: 'monospace, monospace',

    // color: tinycolor('#688aaa').toHex8String(),

    paddingTop: layoutDefaults.smallerVerticalMargin,
    paddingBottom: layoutDefaults.smallerVerticalMargin,
    paddingLeft: layoutDefaults.smallHorizontalMargin,
    paddingRight: layoutDefaults.smallHorizontalMargin,

    // background: ({ loading }) =>
    //   loading === true ? '#a5b8ca' : layoutDefaults.textPlaceholderColor,
    // border: `3px solid white`,
    borderRadius: layoutDefaults.radius,
  },
  description: {
    color: tinycolor(layoutDefaults.primaryColor)
      .setAlpha(layoutDefaults.opacity)
      .toHex8String(),
    fontSize: layoutDefaults.fontSize,

    // opacity: layoutDefaults.opacity,

    marginTop: layoutDefaults.biggerVerticalMargin - 6,

    paddingTop: layoutDefaults.smallVerticalMargin,
    paddingBottom: layoutDefaults.smallVerticalMargin,
    paddingLeft: layoutDefaults.biggerHorizontalMargin,
    paddingRight: layoutDefaults.biggerHorizontalMargin,

    // marginBottom: layoutDefaults.smallVerticalMargin,

    borderRadius: layoutDefaults.radius,

    background: layoutDefaults.cardColor,
    // border: '1px solid red',
  },
  link: {
    cursor: 'pointer',
    fontSize: layoutDefaults.fontSize,
    color: layoutDefaults.linkColor,
    // marginTop: -8,
    // marginBottom: -8,
    // height: 16,
    marginLeft: layoutDefaults.smallestHorizontalMargin,
    padding: 0,
    margin: 0,
  },
});

export { AddressCurrentLocationModalBody };
